import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const FileAddIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fill="currentColor"
                d="M18 8.5V9h1v-.5h-1ZM9.5 21h.5v-1h-.5v1Zm7.735-16.232-.34.366.34-.366Zm.947.882-.341.366.34-.366ZM19 8.5V6.382h-1V8.5h1Zm-.477-3.216-.947-.881-.681.731.946.882.682-.732ZM16.553 4H5.5v1h11.054V4ZM4 5.5v14h1v-14H4ZM5.5 21h4v-1h-4v1ZM4 19.5A1.5 1.5 0 0 0 5.5 21v-1a.5.5 0 0 1-.5-.5H4ZM5.5 4A1.5 1.5 0 0 0 4 5.5h1a.5.5 0 0 1 .5-.5V4Zm12.076.403A1.5 1.5 0 0 0 16.554 4v1a.5.5 0 0 1 .34.134l.682-.731ZM19 6.382a1.5 1.5 0 0 0-.477-1.098l-.682.732a.5.5 0 0 1 .159.366h1Z"
            />
            <path stroke="currentColor" d="M12.5 17.5a5 5 0 1 0 10 0 5 5 0 0 0-10 0ZM17.5 15v5M20 17.5h-5" />
        </svg>
    </IconWrapper>
)
